export const roleOptions = [
  {
    key: 'researcher',
    value: 'researcher',
    label: 'Researcher at an Academic or not-for-profit Institution',
  },
  {
    key: 'representative',
    value: 'representative',
    label: 'Representative from a for-profit or Commercial Entity',
  },
  {
    key: 'developer',
    value: 'developer',
    label: 'Tool or Algorithm Developer',
  },
  {
    key: 'clinician',
    value: 'clinician',
    label: 'Clinician',
  },
  {
    key: 'community_member',
    value: 'community_member',
    label: 'Community Member',
  },
  {
    key: 'federal_employee',
    value: 'federal_employee',
    label: 'Federal Employee',
  },
];

export const usageOptions = [
  {
    key: 'learn_more_about_down_syndrome',
    label:
      'Learning more about Down syndrome and its health outcomes, management, and/or treatment',
    value: 'learn_more_about_down_syndrome',
  },
  {
    key: 'help_design_new_research_study',
    label: 'Helping me design a new research study',
    value: 'help_design_new_research_study',
  },
  {
    key: 'identifying_dataset',
    label: 'Identifying datasets that I want to analyze',
    value: 'identifying_dataset',
  },
  {
    key: 'commercial_purpose',
    label: 'Commercial purposes',
    value: 'commercial_purpose',
  },
];
